import classNames from "classnames";
import { DotsConfirmModal, IDotsConfirmModalProps } from "dots-ui/dotsModal";
import parse from "html-react-parser";
import { useContext } from "react";
import { modalLocalization } from "../../../../localization/modalLocalization";
import { AvisContext } from "../../context/AvisContext";

export function AvisConfirmModal(props: Readonly<IDotsConfirmModalProps>) {
  const { className, content, hideClose = true } = props;
  const { res } = useContext(AvisContext);
  const classNameCombined = classNames("avis-confirm-modal", className);
  const contentParsed = typeof content === "string" ? parse(content) : content;

  return (
    <DotsConfirmModal
      {...props}
      className={classNameCombined}
      hideClose={hideClose}
      localization={modalLocalization(res)}
      content={contentParsed}
      focusableBtn="cancel"
    />
  );
}
